import React from 'react';
import { getText } from '../util/translations';

const Processando = ({ idioma = 'portugues' }) => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
            }}
        >
            <div className="modal-dialog" style={{ margin: 0 }}>
                <div className="modal-content">
                    <div className="modal-body d-flex align-items-center gap-3 px-4 py-3">
                        <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem', flexShrink: 0 }} />
                        <span>{
                            idioma === "both" ?
                                `${getText('loading', 'portugues')} (${getText('loading', 'ingles')})`
                                :
                                getText('loading', idioma)
                        }</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Processando;
